// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menu":"List__menu___30uD4","list":"List__list___uVFiH"};